<template>
	<div class="intro">
		<MainColumn>
			<div class="wrap">
				<Logo size="tiny" color="blue" :confirm="false"/>

				<h1>Condividi le carte</h1>

				<Cards ref="cards" effect="from-top" labelColor="white" context="prepare" />

				<div class="actions">
					<Button value="Rimescola" color="cyan" icon="dice" @click.native="shuffle"/>
					<Button value="Copia link" :text="matchUrl" color="cyan" @click.native="copyLink"/>
					<Button value="Scrivi" color="yellow" @click.native="gotoGame"/>
				</div>
			</div>
		</MainColumn>
		<v-dialog
				v-model="modal"
				width="800"
			>
			<div class="are-you-sure">
				<p class="modal-title">Link copiato!</p>
				<p class="modal-subtitle">Condividilo con chi vuoi</p>
				<div class="buttons">
					<Button @click.native="modal = false" color="cyan" value="Torna alla scelta"/>
					<Button @click.native="$router.push('/gioca')" color="blue" value="Gioca con queste carte"/>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import MainColumn from '@/components/MainColumn.vue';
import Logo from '@/components/Logo.vue';
import Cards from '@/components/Cards.vue';
import Button from '@/components/Button.vue';

export default {
	components: {
		MainColumn,
		Logo,
		Cards,
		Button
	},
	data() {
		return {
			modal: false,
			matchUrl: 'http://mondadori.it/dj/storiediparole/#/game?words=',
		}
	},
	beforeMount() {
		this.matchUrl = this.pickRandomWords();
	},
	mounted() {
		this.updateProperty({
			property: "backgroundColor",
			value: 'indigo darken-4'
		});
		this.resetAllCards();
	},
	methods: {
		shuffle() {
			this.$refs.cards.shuffleCards();
			this.resetAllCards();
			setTimeout(()=>{
				this.matchUrl = this.pickRandomWords();
			}, 500);
		},
		copyLink(){
			navigator.clipboard.writeText(this.matchUrl);
			this.modal = true;
		},
		gotoGame() {
			this.$router.push('/gioca')
		}
	}
}
</script>
<style lang="scss">
	.v-overlay--active {
		backdrop-filter: blur(10px);
	}
	.v-overlay__scrim {
		background-color: rgb(255,255,255) !important;
		backdrop-filter: blur(10px);
	}
	.v-dialog {
		border-radius: 2rem;
	}
	.content .proceed-wrapper {
		display: flex;
		justify-content: flex-end;
	}
</style>
<style scoped lang="scss">
h1 {
	text-align: center;
	color: white;
	font-size: 5rem;
	line-height: 1;
	text-transform: uppercase;
	margin: 2rem 0;
	@include breakpoint(s) {
		font-size: 1.5rem;
		margin: 1.25rem 0 3rem 7rem;
		text-align: left;

	}

}
.actions {
	display: flex;
	gap: 1rem;
	margin: 2rem 0;

	& > :nth-child(1){
		flex-grow: 1;
		flex-basis: 20%;
	}
	& > :nth-child(2){
		flex-grow: 1;
		flex-basis: 60%;
	}
	& > :nth-child(3){
		flex-grow: 1;
		flex-basis: 20%;
	}

	@include breakpoint(s) {
		flex-wrap: wrap;

		& > :nth-child(1),
		& > :nth-child(2),
		& > :nth-child(3){
			flex-basis: 100%;
		}
	}
}


	.are-you-sure {
		border-radius: 20px;
		background: $pink;
		padding: 25px;
		text-align: center;
		color: white;
		.modal-title {
			font-size: px(60);
			line-height: 1;
			color: white;
			text-transform: uppercase;

			@include breakpoint(s) {
				font-size: 2rem;	
			}
		}
		.modal-subtitle {
			font-size: px(30);
			line-height: 1;
			color: white;

			@include breakpoint(s) {
				font-size: 1.25rem;	
			}
		}
		.buttons {
			display: flex;
			justify-content: center;
			margin: px(30) 0 px(50);
			gap: px(25);

			@include breakpoint(s) {
				flex-wrap: wrap;	
			}
		}
	}
</style>